module.exports = __webpack_public_path__ + "img/title7.7e1f1f3f.png";